var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcArticle16Dp = function SvgIcArticle16Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.058
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.867 15h0A1.866 1.866 0 011 13.133V8.467h3.733v4.666A1.866 1.866 0 012.867 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.733 8.467V1H15v12.133A1.866 1.866 0 0113.133 15H2.867M7.533 3.8H12.2M7.533 6.6H12.2M7.533 9.4H12.2m-4.667 2.8H9.4"
  }))));
};

export default "/_next/static/ic_article_16dp-1144fba8d24dbc486be1b62da82d8be3svg";
export { SvgIcArticle16Dp as ReactComponent };